import React from 'react'
import styles from './style.module.scss'

export const Error = ({ children }) => {
	return <div className={styles.error}>{children}</div>
}
